var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 184,
    viewBox: "0 0 217 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1801_3895)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 103.044,
    cy: 93.4024,
    r: 89.9351,
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.7458,
    cy: 32.6765,
    r: 5.63696,
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.538,
    cy: 10.3846,
    rx: 10.5052,
    ry: 10.5052,
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5394,
    cy: 151.309,
    r: 9.99279,
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.385,
    cy: 141.572,
    r: 9.99279,
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.912,
    cy: 152.846,
    r: 4.86828,
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.872 14.5032C120.575 14.44 120.575 14.016 120.872 13.9528L125.364 12.9976C125.472 12.9746 125.557 12.8902 125.58 12.782L126.548 8.32172C126.612 8.02608 127.033 8.02608 127.098 8.32172L128.065 12.782C128.088 12.8902 128.173 12.9746 128.281 12.9976L132.773 13.9528C133.07 14.016 133.07 14.44 132.773 14.5032L128.281 15.4585C128.173 15.4815 128.088 15.5658 128.065 15.674L127.098 20.1343C127.033 20.43 126.612 20.43 126.548 20.1343L125.58 15.674C125.557 15.5658 125.472 15.4815 125.364 15.4585L120.872 14.5032Z",
    fill: "#DBDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4295 93.9764C11.5441 93.4347 12.3175 93.4347 12.4322 93.9764L14.1452 102.069C14.1869 102.267 14.3404 102.421 14.5374 102.464L22.5468 104.209C23.0846 104.326 23.0846 105.093 22.5468 105.21L14.5374 106.955C14.3404 106.998 14.1869 107.152 14.1452 107.35L12.4322 115.443C12.3175 115.984 11.5441 115.984 11.4295 115.443L9.71644 107.35C9.67469 107.152 9.52117 106.998 9.32418 106.955L1.31483 105.21C0.777001 105.093 0.777 104.326 1.31483 104.209L9.32418 102.464C9.52117 102.421 9.67469 102.267 9.71644 102.069L11.4295 93.9764Z",
    fill: "#DBDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.238 31.9701C186.352 31.4283 187.126 31.4283 187.24 31.9701L188.24 36.6913C188.281 36.8885 188.435 37.043 188.632 37.0859L193.318 38.1067C193.856 38.2239 193.856 38.991 193.318 39.1081L188.632 40.1289C188.435 40.1718 188.281 40.3263 188.24 40.5235L187.24 45.2447C187.126 45.7865 186.352 45.7865 186.238 45.2447L185.238 40.5235C185.197 40.3263 185.043 40.1718 184.846 40.1289L180.16 39.1081C179.622 38.991 179.622 38.2239 180.16 38.1067L184.846 37.0859C185.043 37.043 185.197 36.8885 185.238 36.6913L186.238 31.9701Z",
    fill: "#DBDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.896 107.664L208.466 115.077L215.774 116.669L208.466 118.261L206.896 125.675L205.327 118.261L198.019 116.669L205.327 115.077L206.896 107.664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3959 53.6213L65.4221 53.6345L65.449 53.6462C68.5025 54.975 70.7004 56.1253 72.2146 57.1378C73.7538 58.167 74.467 58.9763 74.7309 59.5748C74.9465 60.0637 74.8978 60.4844 74.5328 61.0108C74.1211 61.6047 73.3473 62.252 72.2108 62.988C71.1207 63.6939 69.8009 64.4174 68.3399 65.2185L68.2183 65.2852C66.7229 66.1051 65.1007 66.9981 63.521 67.9973C60.3797 69.9841 57.2724 72.4702 55.5703 75.8409C53.8541 79.2395 53.8816 83.173 54.3828 86.8105C54.6349 88.6403 55.0132 90.4348 55.3748 92.0875C55.4212 92.2997 55.4673 92.5092 55.5128 92.7159C55.8249 94.1356 56.1082 95.4237 56.2849 96.566C56.4906 97.8951 56.5257 98.8815 56.364 99.5543C56.2873 99.8733 56.1762 100.078 56.0551 100.213C55.9401 100.341 55.7723 100.457 55.4922 100.533C54.8793 100.7 53.8001 100.657 51.9921 100.114C50.2303 99.5847 47.9115 98.6241 44.8898 97.1293C36.6762 91.3777 31.0032 85.5124 28.1324 79.6424C25.2805 73.8109 25.1707 67.9373 28.1672 62.0033C34.1304 50.1941 50.708 46.2044 65.3959 53.6213Z",
    fill: "#F6F8F9",
    stroke: "#D4D5D6",
    strokeWidth: 2.0498
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.73596 49.6061L-5.12327 49.5554C7.12792 48.5417 19.3895 51.3838 29.9454 57.6839V57.6839",
    stroke: "#D4D5D6",
    strokeWidth: 2.0498
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.46279 56.6008L-8.44108 56.5129C3.66839 55.4715 15.8029 58.2106 26.2908 64.3529V64.3529",
    stroke: "#D4D5D6",
    strokeWidth: 2.0498
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5121 92.4755C84.9962 99.4381 81.0219 105.082 75.8485 107.924C70.767 110.715 64.3085 110.914 55.5071 106.469C44.2246 100.772 40.2896 85.2379 47.1753 71.6019C54.0564 57.9751 68.8778 51.919 80.1575 57.5966C89.2631 62.7904 92.9229 68.1143 93.6269 73.6602C94.3444 79.3127 92.0444 85.4804 88.5121 92.4755Z",
    fill: "#DBDDDE",
    stroke: "#D4D5D6",
    strokeWidth: 2.0498
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.9794,
    cy: 84.5628,
    rx: 19.5951,
    ry: 26.9656,
    transform: "rotate(-155.936 72.9794 84.5628)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8894 93.6748C87.4443 100.497 82.29 105.601 76.7853 108.36C71.2806 111.12 65.4944 111.511 60.6566 109.068C55.8187 106.626 52.6988 101.737 51.6517 95.6688C50.6047 89.6009 51.6519 82.4233 55.0969 75.6009C58.542 68.7785 63.6964 63.6749 69.201 60.9154C74.7057 58.1557 80.4919 57.7643 85.3298 60.2073C90.1676 62.6502 93.2876 67.5389 94.3346 73.607C95.3817 79.6749 94.3345 86.8525 90.8894 93.6748Z",
    fill: "white",
    stroke: "#D4D5D6",
    strokeWidth: 2.0498
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.929 76.4274C76.9844 74.3373 79.2954 73.5599 81.0101 74.4258C82.7248 75.2917 83.4711 77.6129 82.4157 79.703C81.3603 81.7931 79.0493 82.5705 77.3346 81.7046C75.6199 80.8387 74.8735 78.5175 75.929 76.4274Z",
    fill: "#CCCECF",
    stroke: "#CCCECF",
    strokeWidth: 2.0498
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3297 91.4733C69.3851 89.3832 71.6961 88.6058 73.4108 89.4717C75.1256 90.3376 75.8719 92.6588 74.8164 94.7489C73.761 96.839 71.45 97.6164 69.7353 96.7505C68.0206 95.8846 67.2743 93.5634 68.3297 91.4733Z",
    fill: "#CCCECF",
    stroke: "#CCCECF",
    strokeWidth: 2.0498
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.357 86.2696L121.39 86.2528L121.423 86.2337C140.287 74.9974 162.828 78.7218 171.935 94.0102C181.041 109.299 173.58 130.893 154.716 142.129L154.69 142.145L154.666 142.161C151.984 143.978 149.865 145.129 148.19 145.751C146.507 146.378 145.381 146.429 144.617 146.205C143.896 145.993 143.33 145.485 142.862 144.569C142.38 143.627 142.045 142.328 141.789 140.693C141.536 139.067 141.374 137.198 141.198 135.143L141.189 135.034C141.017 133.022 140.832 130.849 140.533 128.634C139.925 124.129 138.838 119.354 136.362 115.198C133.889 111.045 130.212 107.787 126.544 105.073C124.746 103.742 122.932 102.529 121.25 101.405L121.143 101.333C119.42 100.181 117.855 99.1309 116.546 98.1196C115.231 97.1023 114.247 96.1773 113.646 95.2987C113.061 94.443 112.886 93.7054 113.042 92.9837C113.206 92.2207 113.781 91.2761 115.13 90.1249C116.47 88.9801 118.487 87.7067 121.357 86.2696Z",
    fill: "#F6F8F9",
    stroke: "#D4D5D6",
    strokeWidth: 2.0498
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.656 65.033L209.277 65.7553C201.695 80.1978 189.787 91.9084 175.22 99.2482V99.2482",
    stroke: "#D4D5D6",
    strokeWidth: 2.0498
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.474 55.8799L203.845 57.0867C196.395 71.3902 184.693 83.0317 170.351 90.4075V90.4075",
    stroke: "#D4D5D6",
    strokeWidth: 2.0498
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3381 98.2291L99.9015 94.9153L104.453 92.2041",
    stroke: "#C4CBF5",
    strokeWidth: 2.0498
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.133 92.9221L102.177 92.9013L102.219 92.8765C116.829 84.1746 137.217 90.9427 147.658 108.471C158.096 125.995 154.341 147.14 139.742 155.846C127.589 162.64 118.909 162.991 112.02 159.708C105.026 156.376 99.6123 149.192 94.291 140.258C88.9965 131.37 85.321 122.177 85.7678 113.919C85.9898 109.815 87.2299 105.936 89.8125 102.411C92.4003 98.879 96.3731 95.6523 102.133 92.9221Z",
    fill: "#DBDDDE",
    stroke: "#D4D5D6",
    strokeWidth: 2.0498
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2569 142.066C86.0341 133.297 83.9654 123.822 84.7994 115.615C85.6335 107.407 89.3539 100.54 95.6446 96.7927C101.935 93.0457 109.746 93.0451 117.36 96.2205C124.974 99.3957 132.32 105.728 137.543 114.496C142.766 123.264 144.835 132.74 144.001 140.947C143.167 149.154 139.446 156.022 133.156 159.769C126.865 163.516 119.054 163.517 111.44 160.341C103.826 157.166 96.4797 150.834 91.2569 142.066Z",
    fill: "white",
    stroke: "#D4D5D6",
    strokeWidth: 2.0498
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.882 134.382C124.17 136.544 123.461 139.34 121.299 140.628L90.7814 158.805C88.6197 160.093 85.8236 159.384 84.536 157.222C83.2484 155.061 83.957 152.265 86.1187 150.977L116.637 132.799C118.798 131.512 121.595 132.221 122.882 134.382Z",
    fill: "#F6F8F9",
    stroke: "#CCCECF",
    strokeWidth: 2.0498
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.071 114.909C111.359 117.071 110.65 119.867 108.488 121.154L77.9702 139.332C75.8085 140.62 73.0123 139.911 71.7248 137.749C70.4372 135.588 71.1458 132.791 73.3075 131.504L103.826 113.326C105.987 112.039 108.783 112.747 110.071 114.909Z",
    fill: "#F6F8F9",
    stroke: "#CCCECF",
    strokeWidth: 2.0498
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1801_3895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 216.917,
    height: 184,
    fill: "white",
    transform: "translate(0.0412598)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectAccount);
export default __webpack_public_path__ + "static/media/connectAccount.f084c46cd05b3bc670267d6b725f9a83.svg";
export { ForwardRef as ReactComponent };